import React, { Component } from 'react';

import cn from 'classnames';
import { bool, func, node, oneOf, oneOfType, shape, string } from 'prop-types';

import ClickAwayListener from '@mui/material/ClickAwayListener';
import MUITooltip from '@mui/material/Tooltip';
import withStyles from '@mui/styles/withStyles';

import styles from 'components/Common/Tooltip/styles';

@withStyles(styles)
class Tooltip extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      mobileOpen: false,
    };
  }

  render() {
    const {
      arrow,
      children,
      classes,
      disableInteractive,
      followCursor,
      isMobile,
      onMouseEnter,
      onMouseLeave,
      open,
      placement,
      popperClass,
      title,
      tooltipClass,
    } = this.props;

    const { mobileOpen } = this.state;

    const handleMobileTooltipClose = () => {
      this.setState({ mobileOpen: false });
    };

    const handleMobileTooltipOpen = () => {
      this.setState({ mobileOpen: true });
    };
    const arrowClasses =
      arrow && classes?.arrow
        ? {
            arrow: classes.arrow,
          }
        : {};
    if (arrow && classes?.tooltipArrow) {
      arrowClasses.tooltipArrow = classes.tooltipArrow;
    }
    if (isMobile) {
      return title ? (
        <ClickAwayListener onClickAway={handleMobileTooltipClose}>
          <MUITooltip
            enterTouchDelay={0}
            placement={placement}
            title={<>{title}</>}
            PopperProps={{
              disablePortal: true,
            }}
            classes={{
              tooltip: cn(classes.tooltip, tooltipClass),
              popper: popperClass,
              ...arrowClasses,
            }}
            open={mobileOpen}
            onClose={handleMobileTooltipClose}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            arrow={arrow}
            followCursor={followCursor}
            disableInteractive={disableInteractive}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            <div onClick={handleMobileTooltipOpen} role="button" tabIndex={0}>
              {children}
            </div>
          </MUITooltip>
        </ClickAwayListener>
      ) : (
        <div onClick={handleMobileTooltipOpen} role="button" tabIndex={0}>
          {children}
        </div>
      );
    }

    return title ? (
      <MUITooltip
        enterTouchDelay={0}
        placement={placement}
        title={<>{title}</>}
        classes={{
          tooltip: cn(classes.tooltip, tooltipClass),
          popper: popperClass,
          ...arrowClasses,
        }}
        open={open}
        disableFocusListener
        arrow={arrow}
        followCursor={followCursor}
        disableInteractive={disableInteractive}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </MUITooltip>
    ) : (
      <>{children}</>
    );
  }
}

Tooltip.propTypes = {
  arrow: bool,
  /* children does not accept non single node. It should be wrapped inside the div/span. */
  children: node.isRequired,
  classes: shape({
    tooltip: string,
    arrow: string,
    tooltipArrow: string,
  }),
  disableInteractive: bool,
  followCursor: bool,
  isMobile: bool,
  onMouseEnter: func,
  onMouseLeave: func,
  open: bool,
  placement: oneOf(['right', 'left', 'top', 'bottom']),
  popperClass: string,
  title: oneOfType([string, node]),
  tooltipClass: string,
};

Tooltip.defaultProps = {
  arrow: true,
  classes: {},
  disableInteractive: false,
  followCursor: false,
  isMobile: false,
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  open: undefined,
  placement: 'right',
  popperClass: undefined,
  title: undefined,
  tooltipClass: undefined,
};

export default Tooltip;
